module.exports = __webpack_public_path__ + "img/Apoptosis-CRC_GSE206552.027850b9.png";